<template>
    <div class="col" v-if="!_.isEmpty(providerInfo.text) && !_.isNull(providerInfo.text)">
        <div class="alert alert-danger" style="width:100%;margin-bottom: 10px;">
            <b v-html="providerInfo.text"></b>
        </div>
    </div>
</template>
<script>
  export default{
    props:['providerInfo'],
    computed:{
    },
  }
</script>